import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ontos_page_header = _resolveComponent("ontos-page-header")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_ontos_dialog_action_row = _resolveComponent("ontos-dialog-action-row")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_ontos_dialog = _resolveComponent("ontos-dialog")!

  return (_openBlock(), _createBlock(_component_ontos_dialog, {
    "model-value": true,
    "max-width": _ctx.maxWidth,
    persistent: _ctx.persistent,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closed')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createVNode(_component_ontos_page_header, {
                title: _ctx.title,
                icon: _ctx.icon,
                "icon-color": _ctx.iconColor,
                level: 2
              }, null, 8, ["title", "icon", "icon-color"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, () => [
                _createTextVNode(_toDisplayString(_ctx.message), 1)
              ])
            ]),
            _: 3
          }),
          _createVNode(_component_ontos_dialog_action_row, null, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.actions, (action) => {
                return (_openBlock(), _createBlock(_component_v_btn, {
                  key: action.value,
                  size: "small",
                  color: action.color,
                  variant: action.text ? 'text' : undefined,
                  onClick: ($event: any) => (_ctx.$emit('pick', action.value))
                }, {
                  default: _withCtx(() => [
                    (action.icon)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          size: "small",
                          start: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(action.icon), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(action.label), 1)
                  ]),
                  _: 2
                }, 1032, ["color", "variant", "onClick"]))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["max-width", "persistent"]))
}